<template>
    <div
        class="drop-down-self drop-left"
        v-click-outside="onOutsideClick"
        ref="drop"
    >
        <Icon
            type="md-more"
            size="30"
            color="#FFFFFF"
            @click="showMenu = true"
            style="cursor: pointer"
        />
        <div class="menu" v-if="showMenu" ref="dropMenu">
            <div
                class="menu-item"
                v-for="(item, index) in list"
                :key="index"
                :name="item.key"
                @click="menuItemClick(item)"
            >
                {{ item.text }}
            </div>
        </div>
    </div>
</template>

<script>
import { directive as clickOutside } from 'v-click-outside-x'

export default {
    directives: { clickOutside },
    data() {
        return {
            showMenu: false,
        }
    },
    props: {
        list: {
            type: Array,
            default: () => [
                // { key: "1", text: "test" }
            ],
        },
    },
    methods: {
        onOutsideClick() {
            this.showMenu = false
        },
        menuItemClick(item) {
            this.$emit('on-click', item.key)
        },
    },
    mounted() {
        const el = document.getElementById('roomContainer')
        this.afterContainerResize(el, (el, detector) => {
            const distance =
                detector.windowWidth -
                this.$refs.drop.getBoundingClientRect().right
            if (distance < 175) {
                this.$refs.drop.classList.remove('drop-left')
                this.$refs.drop.classList.add('drop-right')
            } else {
                this.$refs.drop.classList.remove('drop-right')
                this.$refs.drop.classList.add('drop-left')
            }
        })
    },
}
</script>

<style lang="less">
.drop-down-self {
    position: relative;
    color: #515a6e;
    font-size: 12px;

    .menu {
        position: absolute;
        top: 5px;

        background: #fff;
        padding: 5px 0px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        text-align: left;
        &-item {
            white-space: nowrap;
            line-height: 30px;
            padding: 0px 15px;
            cursor: pointer;
        }
        &-item:hover {
            background-color: #f3f3f3;
        }
    }
}
.drop-left {
    .menu {
        left: 30px;
    }
}
.drop-right {
    .menu {
        right: 30px;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
